var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Catalog",
    _vm._g(
      {
        attrs: {
          title: "Категория занятости",
          "name-label": "Название",
          "submit-error": "Укажите название категории занятости.",
          "fetch-data": _vm.fetchData,
          "put-data": _vm.putData,
          "post-data": _vm.postData,
          "exact-id": _vm.exactId
        }
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64def3ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64def3ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/EmploymentCategories/EmploymentCategory.vue
// module id = null
// module chunks = 